<template>
  <v-container style="background-color: white" tag="section" class="content detail">
    <v-row justify="center">
      <v-col>
        <p v-if="$i18n.locale == 'de'" v-html="this.$store.state.modules.options.imprint_de"></p>
        <p v-else v-html="this.$store.state.modules.options.imprint_it"></p>
        <br>
        <hr>
        <br>
        <br>
        <p v-if="$i18n.locale == 'de'" v-html="this.$store.state.modules.options.imprint_jd_de"></p>
        <p v-else v-html="this.$store.state.modules.options.imprint_jd_it"></p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: "imprint",

  mounted() {
  },

};
</script>

<style lang="scss">

</style>
